import React from "react";
import PropTypes from "prop-types";
import ReactCSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import "./index.scss";

const FULL_TRANSITION_DURATION = 300;
const HALF_TRANSITION_DURATION = 200;

const ScaleFadeTransition = ({ children, speed }) => (
	<ReactCSSTransitionGroup
		component={React.Fragment}
		transitionName={`scale-fade-transition--${speed}`}
		transitionEnterTimeout={speed}
		transitionLeaveTimeout={speed}>
		{children}
	</ReactCSSTransitionGroup>
);

ScaleFadeTransition.speeds = {
	Half: HALF_TRANSITION_DURATION,
	Full: FULL_TRANSITION_DURATION,
};

ScaleFadeTransition.propTypes = {
	children: PropTypes.node,
	speed: PropTypes.oneOf(Object.values(ScaleFadeTransition.speeds)),
};

ScaleFadeTransition.defaultProps = {
	children: null,
	speed: ScaleFadeTransition.speeds.Full,
};

export default ScaleFadeTransition;



// WEBPACK FOOTER //
// ./src/shared/components/ScaleFadeTransition/index.jsx